import React from 'react'

const DealerTabs = () => {
  return (
    <section id="c-sectionDealerTabs" className="c-sectionWrapper">
		<div className="container">
			
			<div className="row">
				<div className="col-lg-5 col-md-6 col-12 c-dealerTabBoxCol">
					<ul className="nav nav-tabs" id="c-dealerTab" role="tablist">
						<li className="nav-item">
							<a className="nav-link active" 
								id="tab-be-everywhere1" 						
								href="#tab-be-everywhere" data-toggle="tab"  
								role="tab" 
								aria-controls="tab-be-everywhere1" 
								aria-selected="true">
								<span className="c-dealerTabBox">
									<span className="c-dealerTabBoxIcon">
										<img src="./images/dealer/everywhere.png" alt="" title="" />
									</span>
									<span className="c-dealerTabBoxInfo">
										<span className="c-dealerTabBoxTitle">Pan India</span>
										<span className="c-dealerTabBoxPara">
												Always within reach wherever you want
										</span>
									</span>									
								</span>
							</a>
							<img src="./images/dealer/everywhere.png" className="img-fluid" alt="" title="" />
						</li>
						<li className="nav-item">
							<a className="nav-link" 
								id="tab-build-trust1" 						
								href="#tab-build-trust" data-toggle="tab"  
								role="tab" 
								aria-controls="tab-build-trust" 
								aria-selected="false">
								<span className="c-dealerTabBox">
									<span className="c-dealerTabBoxIcon">
										<img src="./images/dealer/dealer_tab_build_trust_icon.png" alt="" title="" />
									</span>
									<span className="c-dealerTabBoxInfo">
										<span className="c-dealerTabBoxTitle">Build Trust</span>
										<span className="c-dealerTabBoxPara">
											Finayo helps to boost transparency and build trust among Lenders and Buyers.
										</span>
									</span>									
								</span>
							</a>
							<img src="./images/dealer/dealer_tab_build_trust.png" className="img-fluid" alt="" title="" />
						</li>
						<li className="nav-item">
							<a className="nav-link" 
								id="tab-guide-ev-bikers1" 						
								href="#tab-guide-ev-bikers" data-toggle="tab"  
								role="tab" 
								aria-controls="tab-guide-ev-bikers1" 
								aria-selected="false">
								<span className="c-dealerTabBox">
									<span className="c-dealerTabBoxIcon">
										<img src="./images/dealer/dealer_tab_guide_ev_bikers_icon.png" alt="" title="" />
									</span>
									<span className="c-dealerTabBoxInfo">
										<span className="c-dealerTabBoxTitle">Get EV vehicle</span>
										<span className="c-dealerTabBoxPara">
											Choose your EV to apply for a loan and take out your vehicle in few minutes
										</span>
									</span>									
								</span>
							</a>
							<img src="./images/dealer/get-ev.png" className="img-fluid" alt="" title="" />
						</li>
					</ul>
				</div>
				<div className="col-lg-7 col-md-6 col-12 c-dealerTabBoxContentCol">
					<div className="tab-content" id="c-dealerTabContent">
						<div className="tab-pane fade show active" 
							id="tab-be-everywhere" role="tabpanel" 
							aria-labelledby="tab-be-everywhere">
							<img src="./images/dealer/everywhere.png" className="img-fluid" alt="" title="" />
						</div>
						<div className="tab-pane fade" 
							id="tab-build-trust" role="tabpanel" 
							aria-labelledby="tab-build-trust">
							<img src="./images/dealer/dealer_tab_build_trust.png" className="img-fluid" alt="" title="" />
						</div>
						<div className="tab-pane fade" 
							id="tab-guide-ev-bikers" role="tabpanel" 
							aria-labelledby="tab-guide-ev-bikers">
							<img src="./images/dealer/get-ev.png" className="img-fluid" alt="" title="" />
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
  )
}

export default DealerTabs